var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"image-upload"},[(_vm.state != 'loading')?[_c('label',{attrs:{"for":`upload${_vm.api}`}},[_vm._t("default")],2),_c('input',{attrs:{"type":"file","id":`upload${_vm.api}`,"accept":"image/png, image/jpeg"},on:{"change":(e) => _vm.uploadImage(e)}})]:_c('DotLinearLoader')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }